<div *ngIf="loading"  class="loading-panel">
  <div class="loadingio-spinner-double-ring">
    <div class="ldio">
      <div> </div>
      <div> </div>
    </div>
  </div>
</div>
